let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9LGea")).then(() => parcelRequire('9YAnZ'));